import { Reducer } from "redux";

import { DocumentTypeResponse } from "../models/Api/Master";
import { DocumentTypeForPriorAuthDispatchTypes } from "../models/DispatchTypes/Master";
import { DocumentTypeForPriorAuthActionDispatchTypes } from "../constants/Master";
import { setLocalStorageData } from "../utils";

const initialState: DocumentTypeResponse = {
  loading: false,
  response: [],
};

const DocumentTypeForPriorAuthReducer: Reducer<
  DocumentTypeResponse,
  DocumentTypeForPriorAuthDispatchTypes
> = (state = initialState, action) => {
  switch (action.type) {
    case DocumentTypeForPriorAuthActionDispatchTypes.GET_DOCUMENT_TYPE_FOR_PRIOR_AUTH_INVOKE: {
      return {
        ...state,
        loading: true,
      };
    }
    case DocumentTypeForPriorAuthActionDispatchTypes.GET_DOCUMENT_TYPE_FOR_PRIOR_AUTH_SUCCESS: {
      setLocalStorageData(
        DocumentTypeForPriorAuthActionDispatchTypes.GET_DOCUMENT_TYPE_FOR_PRIOR_AUTH_SUCCESS,
        action.response
      );
      return {
        ...state,
        response: action.response,
        loading: false,
      };
    }
    case DocumentTypeForPriorAuthActionDispatchTypes.GET_DOCUMENT_TYPE_FOR_PRIOR_AUTH_RESET: {
      return initialState;
    }
    case DocumentTypeForPriorAuthActionDispatchTypes.GET_DOCUMENT_TYPE_FOR_PRIOR_AUTH_ERROR: {
      return initialState;
    }
  }
  
  return state;
};

export default DocumentTypeForPriorAuthReducer;
